const root = 'UserBasicInfoSettings'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
  emailAddress: `${root}-emailAddress`,
}
